import React from "react";
import "@/App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Team from "./components/Team";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-white">
        <Header />
        <main>
          <Hero />
          <About />
          <Services />
          <Team />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <Toaster richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
